module.exports = __webpack_public_path__ + "img/productWX_7.11a8b6bb.png";